import type { EcommerceItemWithDetails } from '../../../../../types/analytics/ECommerce';
import type { ProductVariant, Variant } from '../../../../../types/CoreShoppingExperience';
import UpgradeType from '../../../../../types/airline/UpgradeType';
import convertToProductDetails from './convertToProductDetails';
import isAutoCampaign from '../../campaign/isAutoCampaign';
import { hasContinuousPricingFromPurchaseOption } from './hasContinuousPricing';

const convertProductToItem = (
  variant: Variant,
  product: ProductVariant,
  variantIndex: number,
): EcommerceItemWithDetails[] => {
  const variantItems = variant.purchaseOptions.map((option) => {
    return {
      itemName: `${variant.upgradeType} - ${option.purchaseMode} - ${option.paymentOption}`,
      index: variantIndex,
      itemBrand: variant.textKey,
      price: option?.paymentBreakdown?.amount ?? 0,
      tax: option?.paymentBreakdown?.taxes?.reduce((acc, iter) => acc + iter.amount, 0) ?? 0,
      fee: option?.paymentBreakdown?.fees?.reduce((acc, iter) => acc + iter.amount, 0) ?? 0,
      quantity: option.quantity.quantity,
      hasSeatMapOption: variant.upgradeType === UpgradeType.EXTRA_SEAT,
      upgradeType: variant.upgradeType,
      fromCabin: variant.fromCabin,
      purchaseMode: option.purchaseMode,
      paymentOption: option.paymentOption,
      purchaseOptionSettings: undefined,
      seats: [],
      blockedSeats: [],
      discount: option.campaign?.percentReduction ?? 0,
      autoCampaign: isAutoCampaign(option.campaign),
      autoCampaignDiscount: option.campaign && isAutoCampaign(option.campaign) ? option.campaign.percentReduction : 0,
      ...convertToProductDetails(product.productDetails),
      continuousPricing: hasContinuousPricingFromPurchaseOption(option),
    };
  });

  const optionalLinkedVariantsItems = (variant.linkedVariants ?? []).flatMap((linkedVariant) =>
    convertProductToItem(linkedVariant, product, variantIndex),
  );

  return [...variantItems, ...optionalLinkedVariantsItems];
};

export default convertProductToItem;
